import React from "react";

// NOTE: Import your actual logos here, replace the placeholder URLs below
// import logo1 from "../assets/logo1.png";
// import logo2 from "../assets/logo2.png";
// import logo3 from "../assets/logo3.png";
// import logo4 from "../assets/logo4.png";

import Yarqin from "../../assets/ym.png";
import TechLogo from "../../assets/teclogo.jpg";

const TrustedPartners = () => {
  // Data array for clients
  const partners = [
    {
      name: "Yarqin Mirzad ISP",
      img: Yarqin,
    }, // Placeholder
    {
      name: "IT Park Uzbekistan",
      img: "https://outsource.gov.uz/_next/static/media/logo.fd681f09.svg",
    },
    {
      name: "National Bank",
      img: TechLogo,
    }, // Placeholder
    {
      name: "E-Gov Agency",
      img: "https://upload.wikimedia.org/wikipedia/commons/thumb/5/51/IBM_logo.svg/200px-IBM_logo.svg.png",
    }, // Placeholder
    // Placeholder
  ];

  return (
    <section className="py-16 bg-white border-b border-slate-100">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-blue-600 font-semibold tracking-wide uppercase text-sm mb-2">
            Trusted By
          </h2>
          <h3 className="text-2xl md:text-3xl font-extrabold text-slate-900">
            Our Valued Partners
          </h3>
        </div>

        {/* Logos Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 items-center justify-items-center">
          {partners.map((partner, index) => (
            <div
              key={index}
              // Container for hover effects
              className="group flex justify-center items-center w-full p-4 transition-all duration-300 hover:scale-105 cursor-pointer"
            >
              <img
                src={partner.img} // Replace with: {partner.img}
                alt={partner.name}
                // Styling: Object-contain keeps aspect ratio, Grayscale makes it professional
                className="h-16 md:h-20 w-auto object-contain opacity-60 grayscale transition-all duration-300 group-hover:opacity-100 group-hover:grayscale-0"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustedPartners;
